import script from "./moreContactsCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./moreContactsCreate.vue?vue&type=script&setup=true&lang=ts"

import "./moreContactsCreate.vue?vue&type=style&index=0&id=267ac6fe&lang=css"

const __exports__ = script;

export default __exports__